"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadPdfFromCloudArgsValidator = exports.getCloudPdfUrl = exports.getEmbeddedMediaCloudFolderUrl = exports.toggleChannelMuteArgsValidator = exports.toggleChannelMuteArgsSchema = exports.updateChannelArgsValidator = exports.updateChannelArgsSchema = exports.PdfFetchInfoSchema = exports.channelProtocolSchema = exports.announcementChannelProtocol = exports.chatChannelProtocol = exports.docChannelProtocol = exports.channelReferenceInfoValidator = exports.channelReferenceInfoSchemaSureType = exports.channelNameValidator = exports.channelNameSchema = exports.CLOUD_STORAGE_BUCKET = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../../common");
exports.CLOUD_STORAGE_BUCKET = "scripto-7f81e.appspot.com";
exports.channelNameSchema = suretype_1.v.string().minLength(1).maxLength(60);
exports.channelNameValidator = (0, suretype_1.compile)(exports.channelNameSchema);
exports.channelReferenceInfoSchemaSureType = suretype_1.v.object({
    id: common_1.idSchema.required(),
    communityId: common_1.idSchema.required(),
});
exports.channelReferenceInfoValidator = (0, suretype_1.compile)(exports.channelReferenceInfoSchemaSureType);
// NOTE protocol of URL is always lower case
exports.docChannelProtocol = "docchannel";
exports.chatChannelProtocol = "chatchannel";
exports.announcementChannelProtocol = "announcementchannel";
exports.channelProtocolSchema = suretype_1.v.string().enum(exports.docChannelProtocol, exports.chatChannelProtocol, exports.announcementChannelProtocol);
// const pdfFetchInfoDescriptionSchema = v.string().maxLength(600)
// export const pdfFetchInfoDescriptionValidator = compile(pdfFetchInfoDescriptionSchema)
exports.PdfFetchInfoSchema = suretype_1.v.anyOf([
    suretype_1.v.object({
        type: suretype_1.v.string().const("url").required(),
        url: common_1.urlSchema.required(),
    }),
    suretype_1.v.object({
        type: suretype_1.v.string().const("fs").required(),
        // description: pdfFetchInfoDescriptionSchema.required()
    }),
    suretype_1.v.object({
        type: suretype_1.v.string().const("cloud").required(),
        // data: v.any().required()
        // downloadURL: urlSchema.required() // idSchema.required()
    }),
]);
// --------------------------
// update channel
// --------------------------
exports.updateChannelArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("toggleChannelMute").required(),
    communityId: common_1.idSchema.required(),
    channelId: common_1.idSchema.required(),
    name: exports.channelNameSchema, // only required if name actually changed
    // description: v.string().maxLength(2000) // only required if description actually changed
});
exports.updateChannelArgsValidator = (0, suretype_1.compile)(exports.updateChannelArgsSchema);
// --------------------------
// toggleChannelMute
// --------------------------
exports.toggleChannelMuteArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("toggleChannelMute").required(),
    communityId: common_1.idSchema.required(),
    channelId: common_1.idSchema.required(),
    value: suretype_1.v.boolean().required()
});
exports.toggleChannelMuteArgsValidator = (0, suretype_1.compile)(exports.toggleChannelMuteArgsSchema);
// --------------------------
// downloadPdfFromCloud
// --------------------------
function getEmbeddedMediaCloudFolderUrl(_a) {
    var communityId = _a.communityId, channelId = _a.channelId;
    return "communities/".concat(communityId, "/channels/").concat(channelId);
}
exports.getEmbeddedMediaCloudFolderUrl = getEmbeddedMediaCloudFolderUrl;
function getCloudPdfUrl(_a) {
    var communityId = _a.communityId, channelId = _a.channelId;
    // NOTE we save the PDF directly under "channels" folder
    // because this makes it easier to delete PDF.
    // This is useful because the PDF is already uploaded before channel creation
    return "communities/".concat(communityId, "/channels/").concat(channelId, ".pdf");
}
exports.getCloudPdfUrl = getCloudPdfUrl;
var downloadPdfFromCloudArgsSchema = suretype_1.v.object({
    communityId: common_1.idSchema.required(),
    channelId: common_1.idSchema.required()
});
exports.downloadPdfFromCloudArgsValidator = (0, suretype_1.compile)(downloadPdfFromCloudArgsSchema);
// const uploadPdfToCloudArgsSchema = v.object({
//     file: v.any().required(),
//     communityId: idSchema.required(),
//     channelId: idSchema.required()
// })
//
// export const uploadPdfToCloudArgsValidator = compile(uploadPdfToCloudArgsSchema)
// export type UploadPdfToCloudArgs = TypeOf<typeof uploadPdfToCloudArgsSchema>
